import SubtitleExportTrialPlaceholder from '@/shared/assets/images/subtitle-export-trial.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';

const TRIAL_PLAN_CONTENT: ModalContent = {
  title: 'Unlock subtitle export',
  bulletsHeader: '',
  buttonText: 'Unlock subtitle export',
  content: {
    allowedPlanNames: ['Creator Pro', 'Business'],
    chip: {
      title: 'Get subtitle export with other Pro tools',
    },
    selectedPlan: 'Creator Pro',
    whatYouCanDo: {
      title: 'What you’ll get',
      bullets: [
        'Export translated subtitles as SRT',
        'Use subtitles in YouTube, editors, or review workflows',
        'Keep timestamps aligned with your video',
      ],
    },
  },
  features: [],
  media: {
    src: SubtitleExportTrialPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: () => MixpanelEvents.trialFeatureUpsellModalUnlockClick({ feature: 'subtitleExport' }),
  mixpanelOpeningEvent: () => MixpanelEvents.trialFeatureUpsellModalShown({ feature: 'subtitleExport' }),
  subtitle: 'Download editable subtitle files for publishing, review, or handoff',
};

export const SUBTITLE_EXPORT_CONTENT: LimitedFeatureContent = {
  trial: TRIAL_PLAN_CONTENT,
};
